(function () {
  "use strict";

  homePreferencesService.$inject = ['preferenceResource'];
  angular
    .module('trainerWebApp.services')
    .factory('homePreferencesService', homePreferencesService);

  function homePreferencesService(preferenceResource) {
    var prefs = {};

    function initializePreferences(value) {
      prefs = angular.copy(value);
    }

    function setPreferences(value) {
      if (!value || angular.equals(value, prefs))
        return;

      preferenceResource.savePreferences(value);
      prefs = angular.copy(value);
    }

    function getPreferences() {
      return angular.copy(prefs);
    }

    return {
      initializePreferences: initializePreferences,
      setPreferences: setPreferences,
      getPreferences: getPreferences
    };
  }

})();
